import { GlobalEvent } from './../common/event';
export class Controller extends GlobalEvent {
}
